var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    enableBackground: "new 0 0 512.13 512.13",
    height: 512,
    viewBox: "0 0 512.13 512.13",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m315.378 292.816c-6.248-6.248-16.379-6.248-22.627 0l-20.687 20.687v-97.373c0-8.836-7.163-16-16-16-8.836 0-16 7.164-16 16v97.372l-20.686-20.686c-6.249-6.248-16.379-6.248-22.628 0-6.248 6.249-6.248 16.379 0 22.628 51.594 51.594 49.078 49.764 53.191 51.468 5.895 2.443 12.798 1.171 17.437-3.468l48-48c6.249-6.248 6.249-16.379 0-22.628z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m336.065 432.13h-160c-8.836 0-16-7.164-16-16s7.164-16 16-16h160c8.837 0 16 7.164 16 16s-7.163 16-16 16z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m448.053 159.897c-.065-4.293-1.819-8.224-4.68-11.085-152.987-152.987-144.538-145.063-147.762-146.789-5.168-2.764 9.424-1.892-196.796-1.892-19.161 0-34.75 15.589-34.75 34.75v442.5c0 19.161 15.589 34.75 34.75 34.75h314.5c19.161 0 34.75-15.589 34.75-34.75 0-4.298.006-316.198-.012-317.484zm-143.988-18.517v-86.622l89.373 89.373c-92.97 0-86.752.031-87.177-.056-1.252-.257-2.196-1.368-2.196-2.695zm112 336c0 1.517-1.233 2.75-2.75 2.75h-314.5c-1.517 0-2.75-1.233-2.75-2.75v-442.5c0-1.517 1.233-2.75 2.75-2.75h173.25v109.25c0 19.161 15.589 34.75 34.75 34.75h109.25z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDownload);
export default __webpack_public_path__ + "static/media/icon-download.72291d51040f30f12812f58f52587064.svg";
export { ForwardRef as ReactComponent };